import { getCountry } from './../api'

// geojs у части гостей недоступен (блокировки, блокировщики рекламы) — тогда страну не знаем и молчим
export const checkVpn = async (toggleNotification: any) => {
  let country
  try {
    country = await getCountry()
  } catch (e) {
    return
  }
  if (country !== 'Russia') {
    toggleNotification({
      status: true,
      text: 'Возможны проблемы с оплатой. <br /> Выключите VPN'
    })
  }
}
